import { render, staticRenderFns } from "./innerUser.vue?vue&type=template&id=71808c1d&scoped=true&"
import script from "./innerUser.vue?vue&type=script&lang=ts&"
export * from "./innerUser.vue?vue&type=script&lang=ts&"
import style0 from "./innerUser.vue?vue&type=style&index=0&id=71808c1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71808c1d",
  null
  
)

export default component.exports